import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APP_TYPE_ADMIN, NOT_SAVABLE_PREFIXES } from "const";
import { LS_LAST_VISITED } from "const/localStorageKeys";

const isNotSavable = (pathname) => {
    return NOT_SAVABLE_PREFIXES.some(p => pathname.startsWith(p));
};

const getServiceKeyFromSearch = (search) => {
    const sp = new URLSearchParams(search || "");
    return sp.get("service");
};

export const useLastVisitedTracker = ({ auth, appType, service }) => {
    const location = useLocation();

    useEffect(() => {
        if (!auth) return;
        if (isNotSavable(location.pathname)) return;

        const serviceKey =
            appType === APP_TYPE_ADMIN
                ? getServiceKeyFromSearch(location.search)
                : null;

        localStorage.setItem(
            LS_LAST_VISITED,
            JSON.stringify({
                pathname: location.pathname,
                search: location.search,
                serviceKey,
                ts: Date.now(),
            })
        );
    }, [auth, appType, service, location.pathname, location.search]);
};